import Model from "@/models/Model";

export default class AddressSimple extends Model {

	public postalSummary!: string | null;
	public phone!: string | null;
	public emails!: string | null;

}
